<div class="returned-electricity" wlAutomationId="returned-electricity-section">
  @if (
    content?.estimationToolIsShown && !content?.estimationToolIsCollapsible
  ) {
    <ng-container *ngTemplateOutlet="numberOfSolarPanelsField" />
  }

  @if (content?.estimationToolIsShown && controls?.doubleMeter?.value) {
    <fieldset>
      <legend class="fs-6 fw-bold">
        <span>{{ content?.returnedElectricityLabel }}</span>
        <wl-tooltip
          [tooltip]="{
            description: content?.returnedElectricityPopoverText,
          }"
          class="ms-1"
        />
      </legend>
      <ng-container *ngTemplateOutlet="returnedElectricityPeakField" />
      <ng-container *ngTemplateOutlet="returnedElectricityOffPeakField" />
    </fieldset>
  } @else {
    <div wlAutomationId="returned-electricity-field">
      @if (content?.estimationToolIsShown) {
        <label [for]="controls?.electricityReturn?.id" class="fw-bold">
          <span>{{ content?.returnedElectricityLabel }}</span>
          <wl-tooltip
            [tooltip]="{
              description: content?.returnedElectricityPopoverText,
            }"
            class="ms-1"
          />
        </label>
      }
      @if (content?.useAccessibleCalculator) {
        <crnt-form-control>
          <crnt-text-input
            [state]="
              !!controls?.electricityReturn?.isValid ? 'enabled' : 'invalid'
            "
          >
            <input
              type="text"
              inputmode="numeric"
              [id]="controls?.electricityReturn?.id"
              [ngrxFormControlState]="controls?.electricityReturn"
              [ngrxValueConverter]="_stringNumberConverter"
            />
            <crnt-icon
              icon="solar-panel"
              slot="leading"
              aria-hidden="true"
              size="base"
            ></crnt-icon>
            <div slot="trailing">{{ content.electricityUsageUnit }}</div>
          </crnt-text-input>
          <crnt-form-control-label slot="label" class="font-normal">{{
            content.returnedElectricityLabel
          }}</crnt-form-control-label>
          @if (controls?.electricityReturn | isInvalid) {
            <crnt-form-control-validation-message
              slot="validation"
              aria-live="polite"
            >
              Controleer je teruglevering
            </crnt-form-control-validation-message>
          }
        </crnt-form-control>
      } @else {
        <wl-input-group
          icon="solar-panel"
          [suffix]="content?.electricityUsageUnit"
          [valid]="controls?.electricityReturn | isValid"
          [invalid]="controls?.electricityReturn | isInvalid"
        >
          <wl-number
            [formsControl]="controls?.electricityReturn"
            [label]="
              !content?.estimationToolIsShown
                ? (content?.returnedElectricityLabel ?? '')
                : ''
            "
            [placeholder]="content?.returnedElectricityPlaceholder ?? ''"
            class="flex-grow-1"
            [step]="0.1"
            fieldName="teruglevering jaar"
            stepName="invullen"
            toolName="keuzehulp"
          />
        </wl-input-group>
        @if (controls?.electricityReturn | isInvalid) {
          @if (controls?.electricityReturn?.errors?.requiredNumber) {
            <wl-input-error
              [messageField]="content?.missingNumericInputErrorMessage"
            />
          }
          @if (controls?.electricityReturn?.errors?.isInt) {
            <wl-input-error
              [messageField]="content?.inputIsNotIntegerErrorMessage"
            />
          }
          @if (controls?.electricityReturn?.errors?.greaterThan) {
            <wl-input-error [messageField]="content?.negativeValueError" />
          }
        }
      }
    </div>
  }

  @if (content?.estimationToolIsShown && content?.estimationToolIsCollapsible) {
    <details class="collapsible-estimation-tool">
      <summary
        class="btn btn-link px-0 py-2 border-0"
        wlTrackLink
        [trackLinkInfo]="{
          rendering: rendering,
          eventType: 'button-click',
          field: 'ESC teruglevering inschatten',
        }"
      >
        <span>{{ content?.collapseEstimationToolButtonText }}</span>
        <crnt-icon icon="chevron-down" class="d-inline-block chevron ms-1" />
      </summary>
      <p class="small mt-1 mb-3">{{ content?.estimationExplanation }}</p>
      <ng-container *ngTemplateOutlet="numberOfSolarPanelsField" />
    </details>
  }
</div>

<ng-template #numberOfSolarPanelsField>
  <div wlAutomationId="number-of-solar-panels-field">
    @if (content?.useAccessibleCalculator) {
      <crnt-form-control>
        <crnt-text-input
          [state]="
            !!controls?.numberOfSolarPanels?.isValid ? 'enabled' : 'invalid'
          "
        >
          <input
            type="text"
            inputmode="numeric"
            [id]="controls?.numberOfSolarPanels?.id"
            [ngrxFormControlState]="controls?.numberOfSolarPanels"
          />
        </crnt-text-input>
        <crnt-form-control-label slot="label">
          <label class="fw-normal" [for]="controls?.numberOfSolarPanels?.id">{{
            content?.numberOfSolarPanelsLabel
          }}</label>
        </crnt-form-control-label>
        <crnt-icon slot="leading" icon="solar-panel"></crnt-icon>
        @if (controls?.numberOfSolarPanels?.isInvalid) {
          @if (controls?.numberOfSolarPanels?.errors?.isInt) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.inputIsNotIntegerErrorMessage }}
            </crnt-form-control-validation-message>
          }
          @if (controls?.numberOfSolarPanels?.errors?.greaterThan) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.negativeValueError }}
            </crnt-form-control-validation-message>
          }
        }
      </crnt-form-control>
    } @else {
      <label [for]="controls?.numberOfSolarPanels?.id" class="fw-bold">
        {{ content?.numberOfSolarPanelsLabel }}
      </label>
      <wl-input-group
        icon="solar-panel"
        [valid]="controls?.numberOfSolarPanels | isValid"
        [invalid]="controls?.numberOfSolarPanels | isInvalid"
      >
        <wl-number
          [formsControl]="controls?.numberOfSolarPanels"
          [placeholder]="content?.numberOfSolarPanelsPlaceholder ?? ''"
          class="flex-grow-1"
          [step]="0.1"
          fieldName="aantal zonnepanelen"
          stepName="teruglevering inschatten"
          toolName="verbruik inschatten"
        />
      </wl-input-group>
      @if (controls?.numberOfSolarPanels | isInvalid) {
        @if (controls?.numberOfSolarPanels?.errors?.isInt) {
          <wl-input-error
            [messageField]="content?.inputIsNotIntegerErrorMessage"
          />
        }
        @if (controls?.numberOfSolarPanels?.errors?.greaterThan) {
          <wl-input-error [messageField]="content?.negativeValueError" />
        }
      }
    }
  </div>
</ng-template>

<ng-template #returnedElectricityPeakField>
  <div class="mb-1" wlAutomationId="returned-peak-electricity-field">
    @if (content?.useAccessibleCalculator) {
      <crnt-form-control>
        <crnt-text-input
          [state]="
            !!controls?.returnedElectricityPeak?.isValid ? 'enabled' : 'invalid'
          "
        >
          <input
            type="text"
            inputmode="numeric"
            [id]="controls?.returnedElectricityPeak?.id"
            [ngrxFormControlState]="controls?.returnedElectricityPeak"
            [ngrxValueConverter]="_stringNumberConverter"
          />
        </crnt-text-input>
        <crnt-form-control-label slot="label">
          <label
            class="fw-normal"
            [for]="controls?.returnedElectricityPeak?.id"
            >{{ content?.returnedElectricityPeakLabel }}</label
          >
        </crnt-form-control-label>
        <crnt-icon slot="leading" icon="solar-panel"></crnt-icon>
        @if (controls?.returnedElectricityPeak | isInvalid) {
          @if (controls?.returnedElectricityPeak?.errors?.requiredNumber) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.missingNumericInputErrorMessage }}
            </crnt-form-control-validation-message>
          }
          @if (controls?.returnedElectricityPeak?.errors?.isInt) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.inputIsNotIntegerErrorMessage }}
            </crnt-form-control-validation-message>
          }
          @if (controls?.returnedElectricityPeak?.errors?.greaterThan) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.negativeValueError }}
            </crnt-form-control-validation-message>
          }
        }
      </crnt-form-control>
    } @else {
      <wl-input-group
        icon="solar-panel"
        [suffix]="content?.electricityUsageUnit"
        [valid]="controls?.returnedElectricityPeak | isValid"
        [invalid]="controls?.returnedElectricityPeak | isInvalid"
      >
        <wl-number
          [formsControl]="controls?.returnedElectricityPeak"
          [label]="content?.returnedElectricityPeakLabel ?? ''"
          [placeholder]="content?.returnedElectricityPeakPlaceholder ?? ''"
          class="flex-grow-1"
          [step]="0.1"
          fieldName="teruglevering jaar piek"
          stepName="invullen"
          toolName="keuzehulp"
        />
      </wl-input-group>
      @if (controls?.returnedElectricityPeak | isInvalid) {
        @if (controls?.returnedElectricityPeak?.errors?.requiredNumber) {
          <wl-input-error
            [messageField]="content?.missingNumericInputErrorMessage"
          />
        }
        @if (controls?.returnedElectricityPeak?.errors?.isInt) {
          <wl-input-error
            [messageField]="content?.inputIsNotIntegerErrorMessage"
          />
        }
        @if (controls?.returnedElectricityPeak?.errors?.greaterThan) {
          <wl-input-error [messageField]="content?.negativeValueError" />
        }
      }
    }
  </div>
</ng-template>

<ng-template #returnedElectricityOffPeakField>
  <div wlAutomationId="returned-off-peak-electricity-field">
    @if (content.useAccessibleCalculator) {
      <crnt-form-control>
        <crnt-text-input
          [state]="
            !!controls?.returnedElectricityOffPeak?.isValid
              ? 'enabled'
              : 'invalid'
          "
        >
          <input
            type="text"
            inputmode="numeric"
            [id]="controls?.returnedElectricityOffPeak?.id"
            [ngrxFormControlState]="controls?.returnedElectricityOffPeak"
            [ngrxValueConverter]="_stringNumberConverter"
          />
        </crnt-text-input>
        <crnt-form-control-label slot="label">
          <label
            class="fw-normal"
            [for]="controls?.returnedElectricityOffPeak?.id"
            >{{ content?.returnedElectricityOffPeak }}</label
          >
        </crnt-form-control-label>
        <crnt-icon slot="leading" icon="solar-panel"></crnt-icon>
        @if (controls?.returnedElectricityOffPeak | isInvalid) {
          @if (controls?.returnedElectricityOffPeak?.errors?.requiredNumber) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.missingNumericInputErrorMessage }}
            </crnt-form-control-validation-message>
          }
          @if (controls?.returnedElectricityOffPeak?.errors?.isInt) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.inputIsNotIntegerErrorMessage }}
            </crnt-form-control-validation-message>
          }
          @if (controls?.returnedElectricityOffPeak?.errors?.greaterThan) {
            <crnt-form-control-validation-message slot="validation">
              {{ content?.negativeValueError }}
            </crnt-form-control-validation-message>
          }
        }
      </crnt-form-control>
    } @else {
      <wl-input-group
        icon="solar-panel"
        [suffix]="content?.electricityUsageUnit"
        [valid]="controls?.returnedElectricityOffPeak | isValid"
        [invalid]="controls?.returnedElectricityOffPeak | isInvalid"
      >
        <wl-number
          [formsControl]="controls?.returnedElectricityOffPeak"
          [label]="content?.returnedElectricityOffPeakLabel ?? ''"
          [placeholder]="content?.returnedElectricityOffPeakPlaceholder ?? ''"
          class="flex-grow-1"
          [step]="0.1"
          fieldName="teruglevering jaar dal"
          stepName="invullen"
          toolName="keuzehulp"
        />
      </wl-input-group>
      @if (controls?.returnedElectricityOffPeak | isInvalid) {
        @if (controls?.returnedElectricityOffPeak?.errors?.requiredNumber) {
          <wl-input-error
            [messageField]="content?.missingNumericInputErrorMessage"
          />
        }
        @if (controls?.returnedElectricityOffPeak?.errors?.isInt) {
          <wl-input-error
            [messageField]="content?.inputIsNotIntegerErrorMessage"
          />
        }
        @if (controls?.returnedElectricityOffPeak?.errors?.greaterThan) {
          <wl-input-error [messageField]="content?.negativeValueError" />
        }
      }
    }
  </div>
</ng-template>
